// frontend/src/api/notifications.js
/**
 * Notifications API — thin wrappers around /api/notifications endpoints (P12-G6/G7b).
 */
import client from "./client";

/**
 * Fetch the current user's unread notifications and the total unread count.
 * @returns {Promise<{unread_count: number, notifications: Array}>}
 */
export async function getNotifications() {
  const response = await client.get("/api/notifications");
  return response.data;
}

/**
 * Mark a single notification as read.
 * @param {string} notificationId UUID of the notification
 * @returns {Promise<object>} The updated notification row
 */
export async function markRead(notificationId) {
  const response = await client.patch(`/api/notifications/${notificationId}/read`);
  return response.data;
}

/**
 * Mark all unread notifications as read.
 * @returns {Promise<{marked_read: number}>}
 */
export async function markAllRead() {
  const response = await client.post("/api/notifications/read-all");
  return response.data;
}

/**
 * Fetch the current user's notification preferences.
 * @returns {Promise<{
 *   user_id: number,
 *   email_scan_milestone: boolean,
 *   email_payment_events: boolean,
 *   email_member_activity: boolean,
 *   email_product_updates: boolean,
 *   inapp_scan_milestone: boolean,
 *   inapp_member_activity: boolean,
 *   email_digest_frequency: string
 * }>}
 */
export async function getNotificationPrefs() {
  const response = await client.get("/api/notifications/preferences");
  return response.data;
}

/**
 * Update the current user's notification preferences (partial update — only
 * include fields you want to change).
 * @param {Partial<{
 *   email_scan_milestone: boolean,
 *   email_payment_events: boolean,
 *   email_member_activity: boolean,
 *   email_product_updates: boolean,
 *   inapp_scan_milestone: boolean,
 *   inapp_member_activity: boolean,
 *   email_digest_frequency: 'immediate'|'daily'|'weekly'
 * }>} updates
 * @returns {Promise<object>} The full updated prefs object
 */
export async function updateNotificationPrefs(updates) {
  const response = await client.put("/api/notifications/preferences", updates);
  return response.data;
}
